var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

export default function extractUsedProps(rule) {
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var usedProps = [];

  // if the browser doesn't support proxies
  // we simply return an empty props object
  // see https://github.com/robinweser/fela/issues/468
  if (typeof Proxy === 'undefined') {
    return usedProps;
  }

  var handler = function handler(props) {
    return {
      get: function get(target, key) {
        if (_typeof(target[key]) === 'object' && target[key] !== null) {
          props.push(key);
          return target[key];
        }
        props.push(key);
        return target[key];
      }
    };
  };

  var proxy = new Proxy({ theme: theme }, handler(usedProps));
  try {
    rule(proxy);
    return usedProps;
  } catch (err) {
    return [];
  }
}